import { render, staticRenderFns } from "./AttributeColorKey.vue?vue&type=template&id=d844a362"
import script from "./AttributeColorKey.vue?vue&type=script&lang=ts"
export * from "./AttributeColorKey.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports